import { onDocumentEvent } from '@app/utils/domHelpers'

function showHideFilters(event) {
  const communicationList = event.target.closest('.export-communications-list')
  const filters = communicationList.querySelector(
    '[data-behaviour="export-communication-filters"]'
  )
  if (event.target.checked) {
    filters.classList.remove('hidden')
  } else {
    filters.classList.add('hidden')
  }
}

function showHideTags(event) {
  const communicationList = event.target.closest('.export-communications-list')
  const tagsList = communicationList.querySelector(
    '[data-behaviour="export-communication-tags"]'
  )
  if (event.target.checked) {
    tagsList.classList.remove('hidden')
  } else {
    tagsList.classList.add('hidden')
  }
}

function handleAllTagsCheckClick(event) {
  const communicationList = event.target.closest('.export-communications-list')
  const allTagsCheck = communicationList.querySelector(
    '[data-behaviour="export-communication-all-tags"]'
  )
  if (allTagsCheck.checked) {
    const singleTagChecks = communicationList.querySelectorAll(
      '[data-behaviour="export-communication-tag"]'
    )
    singleTagChecks.forEach((singleTagCheck) => {
      singleTagCheck.checked = false
    })
  } else {
    handleSingleTagsCheckClick(event)
  }
}

function handleSingleTagsCheckClick(event) {
  const communicationList = event.target.closest('.export-communications-list')
  let anyTagChecked = false

  const singleTagChecks = communicationList.querySelectorAll(
    '[data-behaviour="export-communication-tag"]'
  )
  singleTagChecks.forEach((singleTagCheck) => {
    anyTagChecked = anyTagChecked || singleTagCheck.checked
  })

  const allTagsCheck = communicationList.querySelector(
    '[data-behaviour="export-communication-all-tags"]'
  )
  allTagsCheck.checked = !anyTagChecked
}

function showHideAuthors(event) {
  const communicationList = event.target.closest('.export-communications-list')
  const authorsList = communicationList.querySelector(
    '[data-behaviour="export-communication-authors"]'
  )
  if (event.target.checked) {
    authorsList.classList.remove('hidden')
  } else {
    authorsList.classList.add('hidden')
  }
}

function handleAllAuthorsCheckClick(event) {
  const communicationList = event.target.closest('.export-communications-list')
  const allAuthorsCheck = communicationList.querySelector(
    '[data-behaviour="export-communication-all-authors"]'
  )
  if (allAuthorsCheck.checked) {
    const singleAuthorChecks = communicationList.querySelectorAll(
      '[data-behaviour="export-communication-author"]'
    )
    singleAuthorChecks.forEach((singleAuthorCheck) => {
      singleAuthorCheck.checked = false
    })
  } else {
    handleSingleAuthorsCheckClick(event)
  }
}

function handleSingleAuthorsCheckClick(event) {
  const communicationList = event.target.closest('.export-communications-list')
  let anyAuthorChecked = false

  const singleAuthorChecks = communicationList.querySelectorAll(
    '[data-behaviour="export-communication-author"]'
  )
  singleAuthorChecks.forEach((singleAuthorCheck) => {
    anyAuthorChecked = anyAuthorChecked || singleAuthorCheck.checked
  })

  const allAuthorsCheck = communicationList.querySelector(
    '[data-behaviour="export-communication-all-authors"]'
  )
  allAuthorsCheck.checked = !anyAuthorChecked
}

export default () => {
  const unsubscribers = [
    onDocumentEvent(
      document,
      'change',
      '[data-behaviour="export-communication-filter"]',
      showHideFilters
    ),
    onDocumentEvent(
      document,
      'change',
      '[data-behaviour="export-communication-tags-filter"]',
      showHideTags
    ),
    onDocumentEvent(
      document,
      'change',
      '[data-behaviour="export-communication-all-tags"]',
      handleAllTagsCheckClick
    ),
    onDocumentEvent(
      document,
      'change',
      '[data-behaviour="export-communication-tag"]',
      handleSingleTagsCheckClick
    ),
    onDocumentEvent(
      document,
      'change',
      '[data-behaviour="export-communication-authors-filter"]',
      showHideAuthors
    ),
    onDocumentEvent(
      document,
      'change',
      '[data-behaviour="export-communication-all-authors"]',
      handleAllAuthorsCheckClick
    ),
    onDocumentEvent(
      document,
      'change',
      '[data-behaviour="export-communication-author"]',
      handleSingleAuthorsCheckClick
    ),
  ]

  return () => unsubscribers.forEach((unsubscribe) => unsubscribe())
}
